<template>
  <v-container id="my-groups" fluid tag="section">
    <v-overlay :value="isOverlayVisible">
      <v-progress-circular :size="70" :width="7" color="green" indeterminate class="spinner" />
    </v-overlay>
    <base-v-component heading="Manage Clinics" sub-heading="" />
    <template>
      <v-toolbar flat color="transparent">
        <v-btn color="primary" dark class="mb-2" @click="showClinicEnableDialog">
          <v-icon small class="mr-2">
            mdi-plus
          </v-icon>
          Add New Clinic
        </v-btn>
        <v-btn color="blue" dark class="ml-2 mb-2" @click="showDemoImportModal">
          <v-icon small class="mr-2">
            mdi-upload
          </v-icon>
          Upload demo data
        </v-btn>
      </v-toolbar>
    </template>
    <v-data-table :headers="headers" :items="practices" sort-by="name" class="elevation-1">
      <template v-slot:no-data>
        <p class="mb-4 mt-4">
          No items to display
        </p>
        <v-btn color="primary" outlined class="mb-4" @click="initialize">
          Refresh
        </v-btn>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <div class="senderActions">
          <v-btn
            v-if="!item.isSystemTemplate"
            color="primary"
            outlined
            x-small
            @click="showImportModal(item)"
          >
            Import patients
          </v-btn>
          <v-btn
            v-if="!item.isSystemTemplate"
            color="primary"
            outlined
            x-small
            @click="showDemoImportModal(item)"
          >
            Import demo data
          </v-btn>
        </div>
        <div class="senderActions">
          <v-btn
            v-if="!item.isSystemTemplate"
            color="primary"
            outlined
            x-small
            @click="showClinicEditDialog(item)"
          >
            Edit
          </v-btn>
        </div>
      </template>
      <template v-slot:[`item.healthStatus`]="{ item }">
        <div class="healthWrapper">
          <div v-if="item.healthStatus === 'good'" class="goodHealth"></div>
          <div v-if="item.healthStatus === 'bad'" class="badHealth"></div>
          <div v-if="item.healthStatus === 'neutral'" class="neutralHealth"></div>
        </div>
      </template>
      <template v-slot:[`item.clinicReset`]="{ item }">
        <div class="clinicResetWrapper">
          <clinic-reseter :clinic="item" />
        </div>
      </template>
    </v-data-table>

    <clinic-enable-dialog
      :is-visible="clinicAddEditDailog.isVisible"
      :is-editing="clinicAddEditDailog.isEditMode"
      :clinic="clinicAddEditDailog.selectedClinicToEdit"
      @on-close="hideClinicEnableDialog"
      @on-success="onClinicAddSuccess"
      @on-error="onTwilioProvisionError"
    />

    <clinic-patient-csv-uploader
      :is-visible="clinicImportDialog.isVisible"
      :clinic="clinicImportDialog.selectedClinic"
      @on-close="hideImportModal"
      @on-start="onPatientImportStart"
      @on-success="onPatientImportSuccess"
    />
    <clinic-demo-data-uploader
      :is-visible="demoDataImportDialog.isVisible"
      :clinic="demoDataImportDialog.selectedClinic"
      @on-close="hideDemoImportModal"
      @on-start="onPatientImportStart"
      @on-success="onPatientImportSuccess"
    />

    <v-snackbar v-model="snackbar">
      {{ notification }}

      <template v-slot:action="{ attrs }">
        <v-btn color="pink" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>

    <div class="py-3" />
  </v-container>
</template>

<script>
  /* eslint-disable */
  import { ApiCalls } from "../../../../api-calls";
  import ClinicDemoDataUploader from "../../components/clinic-demo-data-uploader/clinic-demo-data-uploader.vue";

  import ClinicPatientCsvUploader from "../../components/clinic-patient-csv-uploader/clinic-patient-csv-uploader.vue";
  import ClinicReseter from '../../components/clinic-reseter/clinic-reseter.vue';

  export default {
    components: {
      ClinicEnableDialog: () => import("../../components/clinic-enable-dialog/clinic-enable-dialog.vue"),
      ClinicPatientCsvUploader,
      ClinicReseter,
      ClinicDemoDataUploader
    },
    data: () => ({
      clinicAddEditDailog: {
        isVisible: false,
        isEditMode: false,
        selectedClinicToEdit: null
      },
      isEditingClinic: false,
      clinicImportDialog: {
        isVisible: false,
        selectedClinic: null
      },
      demoDataImportDialog: {
        isVisible: false,
        selectedClinic: null
      },
      dialog: false,
      headers: [
        { text: "Company Name", value: "Company" },
        { text: "Practice Id", value: "Practice_ID" },
        { text: "Phone", value: "SendNumber" },
        { text: "Actions", value: "actions", sortable: false }
      ],
      snackbar: false,
      practices: [],
      notification: "Unknown",
      isOverlayVisible: false,
      isFormDirty: false
    }),

    computed: {
      formTitle() {
        return this.editedIndex === -1 ? "New Group" : "Edit Group";
      }
    },

    watch: {
      // dialog (val) {
      //   // val || this.close()
      // },
    },

    async created() {
      this.usremail = localStorage.getItem("username");
      await this.initialize();
    },

    methods: {
      async initialize() {
        this.practices = await this._generateClinicList();
      },
      async _generateClinicList() {
        let allClinics = [];
        this.isOverlayVisible = true;
        try {
          const { data } = await ApiCalls.getPractices();
          console.log("data :>> ", data);
          allClinics = data;
        } catch (error) {
          console.log("error :>> ", error);
        }
        this.isOverlayVisible = false;
        return allClinics;
      },

      showImportModal(item) {
        // console.log('item :>> ', item);
        this.clinicImportDialog = {
          isVisible: true,
          selectedClinic: item
        };
      },
      showDemoImportModal(item = null) {
        this.demoDataImportDialog = {
          isVisible: true,
          selectedClinic: item
        };
      },
      hideDemoImportModal() {
        this.demoDataImportDialog = {
          isVisible: false,
          selectedClinic: null
        };
      },
      hideImportModal() {
        this.clinicImportDialog = {
          isVisible: false,
          selectedClinic: null
        };
      },
      onPatientImportStart() {
        this.isOverlayVisible = true;
      },
      onPatientImportSuccess() {
        this.isOverlayVisible = false;
        this.hideImportModal();
      },
      close() {
        this.dialog = false;
        this.$nextTick(() => {
          this.editedItem = {
            id: -1,
            name: "",
            members: "-",
            messages: "-"
          };
          this.editedIndex = -1;
          this.selectedSenderID = 0;
          this.isFormDirty = false;
        });
      },
      onClinicAddSuccess() {
        this.hideClinicEnableDialog();
        this.initialize();
      },
      showClinicEnableDialog() {
        this.clinicAddEditDailog = {
          isVisible: true,
          isEditMode: false,
          selectedClinicToEdit: null
        }
      },
      showClinicEditDialog(clinic) {
        this.clinicAddEditDailog = {
          isVisible: true,
          isEditMode: true,
          selectedClinicToEdit: clinic
        }
      },
      hideClinicEnableDialog() {
        this.clinicAddEditDailog = {
          isVisible: false,
          isEditMode: false,
          selectedClinicToEdit: null
        }
      },
      onTwilioProvisionError() {
        this.notification = "Unable to add twilio number";
        this.snackbar = true;
      },
      onSpinnerHide() { }
    }
  };
</script>

<style scoped>
.v-overlay.v-overlay--active.theme--dark {
  z-index: 300 !important;
}
.spinner {
  margin-left: 17rem;
}
@media only screen and (max-width: 968px) {
  .spinner {
    margin-left: 0;
  }
}
#bottomTable {
  margin-top: 3rem;
}
</style>

<style scoped lang="scss">
.v-overlay.v-overlay--active.theme--dark {
  z-index: 300 !important;
}
.spinner {
  margin-left: 17rem;
}
@media only screen and (max-width: 968px) {
  .spinner {
    margin-left: 0;
  }
}
.senderActions {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.commBtnWrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}
.quick-comm-btn {
  width: 25px;
  height: 25px;
  display: flex;
  justify-content: center;
  margin-right: 15px;
  align-items: center;
  background-color: rgb(0, 114, 44);
  box-shadow: 5px 5px 8px rgba(0, 0, 0, 0.12);
  color: white;
  font-size: 12px;
  * {
    font-size: 12px;
    color: white;
  }
  border-radius: 100px;
}
.healthWrapper {
  display: flex;
  width: 50px;
  justify-content: center;
  align-items: center;
  .badHealth {
    width: 12px;
    height: 12px;
    border-radius: 12px;
    background-color: rgb(214, 0, 0);
  }
  .goodHealth {
    width: 12px;
    height: 12px;
    border-radius: 12px;
    background-color: green;
  }
  .neutralHealth {
    width: 12px;
    height: 12px;
    border-radius: 12px;
    background-color: rgb(77, 77, 77);
  }
}
</style>
